/**
 * 设备故障信息补录
 */

const prefix = '/dseWeb'
export default [
  // 查询列表（分页）
  { name: 'supplementPage', url: `${prefix}/v1/op/supplement/page`, method: 'post' },
  // 新增或修改
  {
    name: 'insetOrUpdateSupplement',
    url: `${prefix}/v1/op/supplement/insetOrUpdate`,
    method: 'post'
  },
  // 查询单个详情
  { name: 'getSupplementInfoById', url: `${prefix}/v1/op/supplement/info`, method: 'get' },
  // 删除单个详情
  { name: 'deleteSupplement', url: `${prefix}/v1/op/supplement/delete`, method: 'get' },
  // 根据设备id查询列表
  {
    name: 'getErrorListByDeviceId',
    url: `${prefix}/v1/op/supplement/getErrorListByDeviceId`,
    method: 'post'
  }
]
